import { CommonModule, NgIf } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ControllerDetails, ControllerInfo } from 'src/app/models/common/controller-info.model';
import { ControllerStatus } from 'src/app/models/common/controller-status.models';
import { ConfirmationDialogService } from 'src/app/modules/confirmation-dialog/confirmation-dialog.service';
import { AuthserviceService } from 'src/app/services/authservice.service';
import { ControllerService } from 'src/app/services/controller.service';
import { StorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'app-reboot-controller',
  standalone: true,
  imports: [NgIf,CommonModule],
  templateUrl: './reboot-controller.component.html',
  styleUrl: './reboot-controller.component.css'
})
export class RebootControllerComponent implements OnInit {
  @Input() showRebootPopup!:boolean
  @Input({required:true}) controllerDetails!:ControllerDetails
  @Output() closeModal = new EventEmitter()
  controller_info?:ControllerInfo
  
    rebootMessage:string | undefined = undefined
    spinner:boolean = false
    onSubmit:boolean = false
    isHidden:boolean = false
    constructor(private controllerService:ControllerService,private confirmationDialogService: ConfirmationDialogService,  private storage: StorageService,private auth: AuthserviceService,){}
  
    ngOnInit(): void {
      this.getControllerInfo()
    }
  
    async getControllerInfo(){
      const controller_info:ControllerInfo[]= await this.controllerService.getControllerInfo(this.controllerDetails.controller_uuid)
      if(controller_info){
        this.controller_info = controller_info[0]
      }
      
    }
  
    modalClose(){
      this.closeModal.emit(true)
      this.confirmationDialogService.closeDialog(true)
    }
    
    ngOnDestroy() {
      this.confirmationDialogService.closeDialog(true);
  }

  
    async rebootController(){
     
      const controllerStatus:ControllerStatus = await this.controllerService.getControllerStatus(this.controllerDetails.controller_uuid)
      
      if(controllerStatus.controller_status == "online"){
      
      const confimerd = this.confirmationDialogService.confirm('pop up', 'Do you really want to RESTART the controller', 'YES',true,false,"custom-modal-class","CANCEL")
      .then((confirmed) => {
        this.isHidden = false
        if (confirmed) {
          this.spinner = true
          this.rebootApi()
        }
      })
      .catch(() => {
        // Handle the case when the user cancels or dismisses the dialog
      });
      this.isHidden = true
    }
    else{
      this.onSubmit = true
      this.rebootMessage = "Controller is currently offline."
      setTimeout(() => {
        this.onSubmit = false
      },1500)
    }
  }
  
    async rebootApi(){
      const reboot_api_response = await this.controllerService.rebootControllerApi(this.controllerDetails.controller_uuid)
      this.rebootMessage = undefined
      this.rebootMessage ??= reboot_api_response
      setTimeout(() => {
        this.spinner = false
        this.onSubmit = true
        setTimeout(()=>{
          this.onSubmit = false
        },2500)
      },10500)
      
    
  
    }
  
  
}
